<template>
  <div class="list-item">
    <v-text-field
      :error-messages="errorMessages"
      :value="value"
      class="list-item__input"
      :label="$t('message.facilityDetails.services.customService')"
      ref="input"
      :counter="120"
      @input="$emit('input', $event)"
      @blur="$emit('change')"
      @keyup.enter="$emit('add-custom-service')"
    />
    <ui-button
      small
      transparent
      text-color="gray"
      icon="icon-close"
      @click="$emit('remove-custom-service')"
    />
  </div>
</template>

<script>
export default {
  name: "GmbServiceCustomServiceListItem",
  props: {
    value: {
      type: String,
      required: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.focus();
    });
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: flex-end;

  &__input {
    @include font-size(14px);

    ::v-deep.v-label {
      @include font-size(14px);
    }
  }
}
</style>
